import { getToken } from "./utlits";

const apiUrl = process.env.REACT_APP_API_URL || 'https://hutaoadmin.onrender.com/api';

const CREATE_CHECKOUT_SESSION = "stripe/CREATE_CHECKOUT_SESSION";
const FETCH_ORDER_ID = "stripe/FETCH_ORDER_ID";
const FETCH_FEES = "stripe/FETCH_FEES";
const CLEAR_CHECKOUT_SESSION = "stripe/CLEAR_CHECKOUT_SESSION";

export const clearCheckoutSession = () => ({
    type: CLEAR_CHECKOUT_SESSION,
});

const createCheckoutSession = (session) => ({
    type: CREATE_CHECKOUT_SESSION,
    session
});

const fetchOrderId = (orderId) => ({
    type: FETCH_ORDER_ID,
    orderId
});

const fetchFees = (fees) => ({
    type: FETCH_FEES,
    fees
});

export const createCheckoutSessionThunk = (
    tip,
    customTip,
    restaurantId,
    cartItems,
    coupon,
    address,
    name,
    phone,
    time,
    freeItem,
    rewardItem,
    discountReward,
    email,
    aptNumber,
    deliveryInstructions,
    bogoItems,
    delivery_range,
    specialItem
) => async (dispatch) => {
    const token = getToken();

    const response = await fetch(`${apiUrl}/stripe-new/main-payment`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            credentials: 'include',
            'Authorization': `Bearer ${token}`,
        },
        credentials: 'include',
        body: JSON.stringify({
            tip,
            customTip,
            restaurantId,
            cartItems,
            coupon,
            address,
            name,
            phone,
            time,
            freeItem,
            rewardItem,
            discountReward,
            email,
            aptNumber,
            deliveryInstructions,
            bogoItems,
            delivery_range,
            specialItem,
            website_order: true,
        })
    });

    if (response.ok) {
        const data = await response.json();
        dispatch(createCheckoutSession(data));
    }
};

export const fetchFeesThunk = (
    tip,
    customTip,
    restaurantId,
    cartItems,
    address,
    needDelivery,
    coupon,
    phone,
    freeItem,
    bogoId,
    bogoDeal,
    rewardItem,
    discountReward,
    specialItem,
    delivery_range
) => async (dispatch) => {
    const token = getToken();

    const response = await fetch(`${apiUrl}/stripe-new/get-new-fees`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            credentials: 'include',
            'Authorization': `Bearer ${token}`,
        },
        credentials: 'include',
        body: JSON.stringify({
            tip,
            customTip,
            restaurantId,
            cartItems,
            address,
            needDelivery,
            coupon,
            phone,
            freeItem,
            bogoId,
            bogoDeal,
            rewardItem,
            discountReward,
            specialItem,
            delivery_range,
        })
    });

    if (response.ok) {
        const data = await response.json();
        dispatch(fetchFees(data));
    }
};

export const fetchOrderDataThunk = (paymentIntentId) => async (dispatch) => {
    let attempts = 0;
    let orderData = null;

    while (attempts < 6 && !orderData) {
        try {
            const response = await fetch(`${apiUrl}/orders/webhook-response/${paymentIntentId}`);
            if (response.ok) {
                const data = await response.json();

                if (data) {
                    dispatch(fetchOrderId(data));
                    return data;
                }
            }
        } catch (error) {
            console.error("Error fetching order data:", error);
        }

        attempts++;
        await new Promise(resolve => setTimeout(resolve, 6000));
    }

    console.error("Order data not found after multiple attempts.");
    return null;
};

const initialState = {
    data: null,
    orderId: null,
    feeBreakdown: null,
};

const stripeReducer = (state = initialState, action) => {
    switch (action.type) {
        case CREATE_CHECKOUT_SESSION:
            return {
                ...state,
                data: action.session
            };
        case FETCH_ORDER_ID:
            return {
                ...state,
                orderId: action.orderId
            };
        case FETCH_FEES:
            return {
                ...state,
                feeBreakdown: action.fees
            };
        case CLEAR_CHECKOUT_SESSION:
            return {
                ...state,
                data: null,
            };
        default:
            return state;
    }
};

export default stripeReducer;
